import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupsFilter',
  pure: false
})

export class GroupsFilterPipe implements PipeTransform {

  //transform(value: any, input: string) {
  //  if (input) {

  //    input = input.toLowerCase();

  //    return value.filter(function (obj: any) {
  //      if ((obj.fieldName.toLowerCase().indexOf(input) > -1)) {
  //        return obj
  //      }
  //    })
  //  }
  //  return value;
  //}


  transform(value: any[], input: string, trigger: any):any[] {
    if (!value || !input) {
     return value
    }
    input = input.toLowerCase();
    return value.filter(group => group.groupName.toLowerCase().indexOf(input) > -1)
  }


}
